// 以下文件格式为描述路由的协议格式
// 你可以调整 routerConfig 里的内容
// 变量名 routerConfig 为 iceworks 检测关键字，请不要修改名称

import Layout from "@/layouts/Index.vue";

const routerConfig = [
  {
    path: "/",
    redirect: "/main"
  },
  {
    path: "/404",
    component: resolve => require(["@/pages/Error/NotFound.vue"], resolve)
  },

  {
    path: "/main:tab?",
    component: Layout,
    children: [
      {
        path: "",
        component: resolve => require(["@/pages/Main/Index.vue"], resolve),
        name: "Main",
        meta: {
          title: "首页",
          affix: true
        }
      }
    ]
  },
  /**
   * 公众号库存查询
   */
  {
    path: "/productInventory",
    component: Layout,
    children: [
      {
        path: "",
        component: resolve => require(["@/pages/productInventory2/Index.vue"], resolve),
        name: "productInventory",
        meta: {
          title: "库存查询",
          affix: true,
          minimalistPage: true
        }
      }
    ]
  },
  {
    path: "/productInventoryDetails",
    component: Layout,
    children: [
      {
        path: "",
        component: resolve => require(["@/pages/productInventory2/details.vue"], resolve),
        name: "productInventoryDetails",
        meta: {
          title: "库存详情",
          affix: true,
          minimalistPage: true
        }
      }
    ]
  },
  {
    path: "*",
    redirect: "/404"
  }
];

export default routerConfig;
